export const API_TYPES = {
  shift: "shift",
  shiftSchedule: "shift-schedule",
  workplace: "workplace",
  worker: "worker",
  shiftLog: "shift-log",
} as const;
